import image1 from "./images/mill.webp";
import image2 from "./images/mill_2.webp";
import image3 from "./images/mill_3.webp";
import image4 from "./images/Peachtree_DJka.webp";
import image5 from "./images/Tray.webp";
import image6 from "./images/fountain.webp";
import image7 from "./images/Donut.webp";
import image8 from "./images/Bar.webp";
import image9 from "./images/Bar_2.webp";
import image10 from "./images/automat.webp";
import image11 from "./images/automat_3.webp";
import image12 from "./images/automat_4.webp";

export const images = [
    { src: image1, title: "Front view of 3D visualization of a marketing installation in the form of a mill" },
    { src: image2, title: "Front view of 3D visualization of a marketing installation in the form of a wooden mill" },
    { src: image3, title: "Back view of 3D visualization of a marketing installation in the form of a mill" },
    { src: image4, title: "Fron view of 3D visualization of a DJ booth for a marketing event" },
    { src: image5, title: "Fron view of 3D visualization of a mountain-shaped tray for shot glasses" },
    { src: image6, title: "Fron view of 3D visualization of a decorative fountain" },
    { src: image7, title: "Fron view of 3D donut model" },
    { src: image8, title: "Fron view of 3D visualization of the zone and bar layout for the festival" },
    { src: image9, title: "Back view of 3D visualization of the zone and bar layout for the festival" },
    { src: image10, title: "Fron view of 3D visualization of a bar styled as a vending machine" },
    { src: image11, title: "Fron view of 3D visualization of a bar styled as a vending machine, including a person model for scale" },
    { src: image12, title: "Detail of 3D visualization of a bar styled as a vending machine"}
];